module.exports = __webpack_public_path__ + "img/area_xn.1711005f.png";